export enum RoleEnum {
    ADMIN = "admin",
    COMPANY = "company",
}
